/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-tablo-bord-abonnement': {
    width: 78.312,
    height: 78.299,
    viewBox: '0 136 78.312 78.299',
    data: '<path pid="0" d="M72.9 141.701l-.301-.301c-7.199-7.199-19-7.199-26.199 0l-16.7 16.7c-7.2 7.2-7.2 19 0 26.2l.3.3c.601.601 1.2 1.101 1.9 1.601L38 180.1a9.467 9.467 0 0 1-2-1.5l-.3-.3c-3.9-3.899-3.9-10.301 0-14.2l16.7-16.7c3.898-3.9 10.3-3.9 14.199 0l.301.301c3.898 3.898 3.898 10.299 0 14.199l-7.5 7.5c1.3 3.199 1.898 6.699 1.898 10.1L73 167.8c7.1-7.099 7.1-18.9-.1-26.099m-24.6 24a14.527 14.527 0 0 0-1.898-1.602l-6.102 6.102c.7.398 1.4.898 2 1.5l.3.299c3.899 3.9 3.899 10.301 0 14.201L25.9 202.9c-3.9 3.898-10.3 3.898-14.2 0l-.3-.301c-3.9-3.898-3.9-10.301 0-14.199l7.5-7.5c-1.3-3.199-1.9-6.699-1.9-10.102L5.4 182.4c-7.2 7.199-7.2 19 0 26.199l.3.301c7.2 7.199 19 7.199 26.2 0l16.7-16.699c7.199-7.201 7.199-19 0-26.201l-.3-.299z"/>'
  }
})
